import IRole from "./IRole";

export enum IUserStatusType {
    Active = 'Active',
    InActive = 'InActive'
  }

export default interface IUser {
    uid: string,
    userName: string,
    title: string,
    image?: string,
    firstName: string,
    lastName: string,
    status: IUserStatusType,
    lastLogin?: Date,
    phone: string,
    email: string,
    password?: string,
    createdOn: Date,
    roles: Array<IRole>
}